/**
 * ИКОНКИ ПРОДУКТА - ТОЛЬКО HUGEICONS, БИБЛИОТЕКА ПРЕСЕТА b1FSSCOCO.
 *
 * До единицы 15 здесь жил Fluent (Microsoft) через Iconify: имя иконки было
 * классом (`icon-[fluent--home-24-regular]`), а рисовал её плагин Tailwind
 * фоновым изображением. Пресет объявляет свою библиотеку, и держать вторую
 * значило держать два набора очертаний в одном интерфейсе - а заодно плагин
 * и два пакета Iconify в зависимостях.
 *
 * ПУТЬ У КАЖДОЙ ИКОНКИ СВОЙ - не общий файл пакета. В общем файле
 * `@hugeicons/core-free-icons@4.3.4` шесть иконок сетки перечислены с
 * неверным регистром (`Grid2x2CheckIcon` вместо `Grid2X2CheckIcon`): на
 * macOS сборка проходит, на Linux - CI и Cloudflare Pages - падает шестью
 * «Module not found». Поимённый путь общего файла не касается; заодно в
 * сборку не тянется перечисление двенадцати тысяч иконок. Это правило
 * сторожат ворота дисциплины UI (`pnpm ui:check`).
 *
 * Имя слева - СМЫСЛ в продукте, а не название очертания: место вызова
 * просит «значок эфира», а не «LiveStreaming01». Смена библиотеки тогда
 * остаётся правкой одного этого файла - ею она и оказалась.
 */
import Home01Icon from '@hugeicons/core-free-icons/Home01Icon';
import Menu01Icon from '@hugeicons/core-free-icons/Menu01Icon';
import Cancel01Icon from '@hugeicons/core-free-icons/Cancel01Icon';
import ArrowRight01Icon from '@hugeicons/core-free-icons/ArrowRight01Icon';
import ArrowDown01Icon from '@hugeicons/core-free-icons/ArrowDown01Icon';
import ArrowRight02Icon from '@hugeicons/core-free-icons/ArrowRight02Icon';
import RefreshIcon from '@hugeicons/core-free-icons/RefreshIcon';
import ArrowReloadHorizontalIcon from '@hugeicons/core-free-icons/ArrowReloadHorizontalIcon';
import LinkSquare01Icon from '@hugeicons/core-free-icons/LinkSquare01Icon';
import Search01Icon from '@hugeicons/core-free-icons/Search01Icon';
import Settings01Icon from '@hugeicons/core-free-icons/Settings01Icon';
import UserIcon from '@hugeicons/core-free-icons/UserIcon';
import Logout01Icon from '@hugeicons/core-free-icons/Logout01Icon';
import PlusSignIcon from '@hugeicons/core-free-icons/PlusSignIcon';
import Delete02Icon from '@hugeicons/core-free-icons/Delete02Icon';
import Edit02Icon from '@hugeicons/core-free-icons/Edit02Icon';
import Copy01Icon from '@hugeicons/core-free-icons/Copy01Icon';
import ViewIcon from '@hugeicons/core-free-icons/ViewIcon';
import ViewOffIcon from '@hugeicons/core-free-icons/ViewOffIcon';
import Link01Icon from '@hugeicons/core-free-icons/Link01Icon';
import SquareLock01Icon from '@hugeicons/core-free-icons/SquareLock01Icon';
import PlayIcon from '@hugeicons/core-free-icons/PlayIcon';
import PauseIcon from '@hugeicons/core-free-icons/PauseIcon';
import StopIcon from '@hugeicons/core-free-icons/StopIcon';
import Clock01Icon from '@hugeicons/core-free-icons/Clock01Icon';
import Timer01Icon from '@hugeicons/core-free-icons/Timer01Icon';
import Notification01Icon from '@hugeicons/core-free-icons/Notification01Icon';
import CrownIcon from '@hugeicons/core-free-icons/CrownIcon';
import Analytics01Icon from '@hugeicons/core-free-icons/Analytics01Icon';
import HistoryIcon from '@hugeicons/core-free-icons/HistoryIcon';
import HandshakeIcon from '@hugeicons/core-free-icons/HandshakeIcon';
import ArrowLeft01Icon from '@hugeicons/core-free-icons/ArrowLeft01Icon';
import ArrowUp01Icon from '@hugeicons/core-free-icons/ArrowUp01Icon';
import DashboardSquare01Icon from '@hugeicons/core-free-icons/DashboardSquare01Icon';
import Sun01Icon from '@hugeicons/core-free-icons/Sun01Icon';
import Moon02Icon from '@hugeicons/core-free-icons/Moon02Icon';
import InformationCircleIcon from '@hugeicons/core-free-icons/InformationCircleIcon';
import CheckmarkCircle02Icon from '@hugeicons/core-free-icons/CheckmarkCircle02Icon';
import Alert02Icon from '@hugeicons/core-free-icons/Alert02Icon';
import AlertCircleIcon from '@hugeicons/core-free-icons/AlertCircleIcon';
import Tick02Icon from '@hugeicons/core-free-icons/Tick02Icon';
import CircleIcon from '@hugeicons/core-free-icons/CircleIcon';
import LiveStreaming01Icon from '@hugeicons/core-free-icons/LiveStreaming01Icon';
import Video01Icon from '@hugeicons/core-free-icons/Video01Icon';
import GameboyIcon from '@hugeicons/core-free-icons/GameboyIcon';
import GiftIcon from '@hugeicons/core-free-icons/GiftIcon';
import FavouriteIcon from '@hugeicons/core-free-icons/FavouriteIcon';
import BubbleChatIcon from '@hugeicons/core-free-icons/BubbleChatIcon';
import Share01Icon from '@hugeicons/core-free-icons/Share01Icon';
import UserAdd01Icon from '@hugeicons/core-free-icons/UserAdd01Icon';
import UserGroupIcon from '@hugeicons/core-free-icons/UserGroupIcon';
import VolumeHighIcon from '@hugeicons/core-free-icons/VolumeHighIcon';
import VolumeMute01Icon from '@hugeicons/core-free-icons/VolumeMute01Icon';
import MixerIcon from '@hugeicons/core-free-icons/MixerIcon';
import Grid02Icon from '@hugeicons/core-free-icons/Grid02Icon';
import Upload01Icon from '@hugeicons/core-free-icons/Upload01Icon';
import DragDropVerticalIcon from '@hugeicons/core-free-icons/DragDropVerticalIcon';
import Layout01Icon from '@hugeicons/core-free-icons/Layout01Icon';
import UserCircleIcon from '@hugeicons/core-free-icons/UserCircleIcon';
import BrowserIcon from '@hugeicons/core-free-icons/BrowserIcon';
import FlashIcon from '@hugeicons/core-free-icons/FlashIcon';
import Shield01Icon from '@hugeicons/core-free-icons/Shield01Icon';
import ComputerIcon from '@hugeicons/core-free-icons/ComputerIcon';
import SmartPhone01Icon from '@hugeicons/core-free-icons/SmartPhone01Icon';
import GlobeIcon from '@hugeicons/core-free-icons/GlobeIcon';
import Mail01Icon from '@hugeicons/core-free-icons/Mail01Icon';
import SparklesIcon from '@hugeicons/core-free-icons/SparklesIcon';
import ChampionIcon from '@hugeicons/core-free-icons/ChampionIcon';
import Coins01Icon from '@hugeicons/core-free-icons/Coins01Icon';
import Target01Icon from '@hugeicons/core-free-icons/Target01Icon';
import QrCodeIcon from '@hugeicons/core-free-icons/QrCodeIcon';
import ClipboardCheckIcon from '@hugeicons/core-free-icons/ClipboardCheckIcon';
import Pulse01Icon from '@hugeicons/core-free-icons/Pulse01Icon';
export const ICONS = {
    home: Home01Icon,
    menu: Menu01Icon,
    dismiss: Cancel01Icon,
    chevronRight: ArrowRight01Icon,
    chevronDown: ArrowDown01Icon,
    arrowRight: ArrowRight02Icon,
    arrowSync: RefreshIcon,
    arrowReset: ArrowReloadHorizontalIcon,
    open: LinkSquare01Icon,
    search: Search01Icon,
    settings: Settings01Icon,
    person: UserIcon,
    signOut: Logout01Icon,
    add: PlusSignIcon,
    delete: Delete02Icon,
    edit: Edit02Icon,
    copy: Copy01Icon,
    eye: ViewIcon,
    eyeOff: ViewOffIcon,
    link: Link01Icon,
    lock: SquareLock01Icon,
    play: PlayIcon,
    pause: PauseIcon,
    stop: StopIcon,
    clock: Clock01Icon,
    timer: Timer01Icon,
    bell: Notification01Icon,
    crown: CrownIcon,
    chart: Analytics01Icon,
    history: HistoryIcon,
    handshake: HandshakeIcon,
    chevronLeft: ArrowLeft01Icon,
    chevronUp: ArrowUp01Icon,
    widgets: DashboardSquare01Icon,
    sun: Sun01Icon,
    moon: Moon02Icon,
    info: InformationCircleIcon,
    success: CheckmarkCircle02Icon,
    warning: Alert02Icon,
    error: AlertCircleIcon,
    check: Tick02Icon,
    circle: CircleIcon,
    live: LiveStreaming01Icon,
    video: Video01Icon,
    games: GameboyIcon,
    gift: GiftIcon,
    heart: FavouriteIcon,
    chat: BubbleChatIcon,
    share: Share01Icon,
    personAdd: UserAdd01Icon,
    people: UserGroupIcon,
    sound: VolumeHighIcon,
    soundOff: VolumeMute01Icon,
    mixer: MixerIcon,
    pads: Grid02Icon,
    upload: Upload01Icon,
    drag: DragDropVerticalIcon,
    layout: Layout01Icon,
    channel: UserCircleIcon,
    overlay: BrowserIcon,
    binding: FlashIcon,
    shield: Shield01Icon,
    desktop: ComputerIcon,
    phone: SmartPhone01Icon,
    globe: GlobeIcon,
    mail: Mail01Icon,
    sparkle: SparklesIcon,
    trophy: ChampionIcon,
    coins: Coins01Icon,
    target: Target01Icon,
    qr: QrCodeIcon,
    clipboardCheck: ClipboardCheckIcon,
    pulse: Pulse01Icon,
};
//# sourceMappingURL=icons.js.map